import { render } from "./PersoneGiuridiche.vue?vue&type=template&id=7fc1251f"
import script from "./PersoneGiuridiche.vue?vue&type=script&lang=js"
export * from "./PersoneGiuridiche.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francescoscialacqua/Sviluppo/emmet.client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__